// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { memo } from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

export const TrashIllustration = ({ width = 182, height = 202 }) => (
  <Svg width={width} height={height} viewBox="0 0 182 202" fill="none">
    <G clipPath="url(#clip0_10271_164767)">
      <Path
        d="M107.076 81.3038C100.772 86.3118 89.8841 92.0238 76.9801 96.7278C75.8041 97.1518 74.6521 97.5598 73.5001 97.9518L65.8521 87.5838H65.8441L63.3961 75.0878L62.7961 72.0158C62.2441 69.1918 64.0841 66.4638 66.9001 65.9118L70.6841 65.1758H70.6921L93.7641 60.6478L97.8761 59.8478C100.692 59.2958 103.428 61.1358 103.98 63.9518L105.044 69.4078L105.076 69.5838C104.964 69.5838 104.852 69.5838 104.74 69.5838L107.076 81.3118V81.3038Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M86.2358 178.032C86.0358 178.544 85.6438 178.952 85.1478 179.176C84.6518 179.4 84.0838 179.416 83.5718 179.224C83.0598 179.032 82.6438 178.64 82.4198 178.144L56.1958 119.448C55.9718 118.952 55.9558 118.384 56.1558 117.872C56.3558 117.36 56.7478 116.952 57.2438 116.728C57.7398 116.504 58.3078 116.488 58.8198 116.68C59.3318 116.872 59.7478 117.264 59.9718 117.76L86.1958 176.456H86.2038C86.4198 176.952 86.4358 177.52 86.2358 178.032Z"
        fill="#F3123C"
      />
      <Path
        d="M106.46 172.136C106.444 172.408 106.38 172.672 106.268 172.92C106.148 173.168 105.988 173.392 105.788 173.576C105.588 173.76 105.356 173.904 105.1 174C104.844 174.096 104.572 174.136 104.3 174.128C104.028 174.112 103.764 174.048 103.516 173.936C103.268 173.816 103.044 173.656 102.86 173.456C102.676 173.256 102.532 173.024 102.436 172.768L80.5881 112.72C80.4041 112.208 80.4361 111.64 80.6681 111.144C80.9001 110.648 81.3161 110.272 81.8281 110.08C82.3401 109.896 82.9081 109.92 83.4041 110.144C83.9081 110.368 84.2921 110.784 84.4841 111.296L106.332 171.336C106.428 171.592 106.468 171.864 106.46 172.136Z"
        fill="#F3123C"
      />
      <Path
        d="M124.924 164.152C124.66 164.624 124.22 164.968 123.7 165.112C123.188 165.256 122.628 165.2 122.156 164.944C121.676 164.696 121.324 164.264 121.156 163.752L103.524 101.92C103.38 101.392 103.452 100.832 103.716 100.352C103.988 99.8799 104.428 99.5279 104.956 99.3759C105.484 99.2239 106.044 99.2879 106.524 99.5519C107.004 99.8159 107.356 100.256 107.516 100.776L125.148 162.608H125.14C125.268 163.136 125.196 163.688 124.924 164.152Z"
        fill="#F3123C"
      />
      <Path
        d="M46.3239 94.0403L42.1559 88.4323L42.1479 88.4242H42.1559L43.1879 87.6562H43.1959L46.3239 94.0403Z"
        fill="#404040"
      />
      <Path
        d="M45.212 104.224H45.188C45.02 104.224 44.852 104.24 44.684 104.248C44.46 104.256 44.244 104.264 44.028 104.272C43.404 104.288 42.804 104.288 42.228 104.272C41.948 104.272 41.676 104.256 41.412 104.24C41.148 104.232 40.876 104.208 40.604 104.192C40.428 104.176 40.252 104.168 40.084 104.144C39.796 104.112 39.508 104.08 39.228 104.04C39.228 104.04 39.2227 104.04 39.212 104.04C38.372 103.912 37.58 103.744 36.868 103.504C36.644 103.432 36.436 103.352 36.236 103.264C35.364 102.888 34.668 102.392 34.276 101.728C34.164 101.552 34.092 101.352 34.028 101.144C33.916 100.784 33.876 100.408 33.916 99.992C33.916 99.936 33.924 99.888 33.932 99.832C33.94 99.76 33.956 99.68 33.972 99.608C33.988 99.496 34.012 99.384 34.052 99.272C34.084 99.144 34.124 99.016 34.18 98.88C34.22 98.768 34.268 98.656 34.316 98.544C34.372 98.424 34.428 98.312 34.484 98.192C34.604 97.96 34.748 97.72 34.9 97.48C34.98 97.36 35.06 97.232 35.148 97.112C35.236 96.992 35.324 96.864 35.42 96.736C35.612 96.488 35.82 96.232 36.044 95.976C36.34 95.624 36.676 95.272 37.036 94.92C37.212 94.744 37.396 94.568 37.588 94.384C37.98 94.024 38.388 93.656 38.828 93.28C39.044 93.088 39.276 92.904 39.508 92.72C39.74 92.528 39.98 92.336 40.228 92.152C40.476 91.952 40.732 91.76 40.988 91.576C41.244 91.392 41.508 91.2 41.78 91H41.788L40.772 98.136V98.184L45.212 104.216V104.224Z"
        fill="#404040"
      />
      <Path
        d="M112.908 73.2802C112.924 73.4802 112.924 73.6802 112.908 73.8882L112.884 74.0562C112.868 74.1362 112.86 74.2082 112.844 74.2882C112.796 74.5042 112.732 74.7282 112.644 74.9602C112.62 75.0162 112.596 75.0802 112.572 75.1442C112.548 75.2082 112.516 75.2722 112.492 75.3362C112.476 75.3682 112.46 75.4002 112.444 75.4322C112.436 75.4562 112.42 75.4882 112.404 75.5202C112.372 75.5842 112.34 75.6482 112.3 75.7122C112.26 75.7922 112.212 75.8722 112.164 75.9522C112.14 76.0162 112.1 76.0722 112.068 76.1282C111.988 76.2562 111.916 76.3762 111.828 76.5042C111.612 76.8242 111.364 77.1522 111.092 77.4882C110.396 78.3522 109.564 79.1922 108.716 79.9362C108.58 80.0562 108.444 80.1762 108.3 80.3042C108.092 80.4882 107.884 80.6642 107.676 80.8322C107.476 81.0002 107.276 81.1602 107.076 81.3202V81.3042L104.74 69.5762C104.852 69.5762 104.964 69.5762 105.076 69.5922C105.172 69.5922 105.268 69.5922 105.356 69.6002C105.548 69.6082 105.748 69.6162 105.956 69.6322C107.1 69.7042 108.38 69.8722 109.516 70.2082C109.78 70.2722 110.028 70.3602 110.268 70.4562C110.316 70.4722 110.364 70.4882 110.412 70.5122C110.62 70.6002 110.812 70.6882 110.996 70.7842C111.092 70.8322 111.188 70.8882 111.276 70.9442C111.484 71.0722 111.676 71.2162 111.852 71.3602C111.948 71.4402 112.036 71.5202 112.116 71.6082C112.196 71.6882 112.276 71.7762 112.34 71.8642C112.34 71.8642 112.346 71.8695 112.356 71.8802C112.42 71.9602 112.476 72.0402 112.524 72.1282C112.58 72.2242 112.628 72.3122 112.668 72.4082C112.716 72.4962 112.756 72.5922 112.78 72.6882C112.82 72.7922 112.844 72.8962 112.868 73.0082C112.868 73.0162 112.868 73.0242 112.868 73.0322C112.868 73.0642 112.876 73.1042 112.884 73.1442C112.892 73.1842 112.892 73.2322 112.9 73.2802H112.908Z"
        fill="#404040"
      />
      <Path
        d="M65.5559 87.1773V87.1933L63.3159 84.1533L62.8279 83.4893L60.7959 80.7293V80.7133C61.8359 80.2573 62.9159 79.8013 63.9959 79.3613V79.3773H64.0039L65.5479 87.1693H65.5559V87.1773Z"
        fill="#404040"
      />
      <Path
        d="M138.068 161.449L112.876 73.0332C112.876 73.0332 112.884 73.1052 112.892 73.1452C112.9 73.1852 112.9 73.2332 112.908 73.2812C112.924 73.4812 112.924 73.6812 112.908 73.8892L112.884 74.0572C112.868 74.1372 112.86 74.2092 112.844 74.2892C112.796 74.5052 112.732 74.7292 112.644 74.9612C112.62 75.0172 112.596 75.0812 112.572 75.1452C112.548 75.2092 112.516 75.2732 112.492 75.3372C112.476 75.3692 112.46 75.4012 112.444 75.4332C112.436 75.4572 112.42 75.4892 112.404 75.5212C112.372 75.5852 112.34 75.6492 112.3 75.7132C112.26 75.7932 112.212 75.8732 112.164 75.9532C112.14 76.0172 112.1 76.0732 112.068 76.1292C111.988 76.2572 111.916 76.3772 111.828 76.5052C111.612 76.8252 111.364 77.1532 111.092 77.4892C110.396 78.3532 109.564 79.1932 108.716 79.9372C108.58 80.0572 108.444 80.1772 108.3 80.3052C108.18 80.4092 108.052 80.5132 107.924 80.6172C107.844 80.6972 107.764 80.7692 107.676 80.8332C107.476 81.0012 107.276 81.1612 107.076 81.3212V81.3052C100.772 86.3132 89.8839 92.0252 76.9799 96.7292C75.8039 97.1532 74.6519 97.5612 73.4999 97.9532H73.4919C62.5319 101.665 52.4599 103.825 45.2119 104.225H45.1879C45.0199 104.225 44.8519 104.241 44.6839 104.249C44.4599 104.257 44.2439 104.265 44.0279 104.273C43.4039 104.289 42.8039 104.289 42.2279 104.273C41.9479 104.273 41.6759 104.257 41.4119 104.241C41.1319 104.233 40.8679 104.217 40.6039 104.193C40.4279 104.177 40.2519 104.169 40.0839 104.145C39.7879 104.121 39.5079 104.081 39.2279 104.041C39.2279 104.041 39.2225 104.041 39.2119 104.041C38.3719 103.929 37.6199 103.761 36.9719 103.545C36.9399 103.537 36.8999 103.521 36.8679 103.505C36.6439 103.433 36.4359 103.353 36.2359 103.265C35.3639 102.889 34.6679 102.393 34.2759 101.729L71.7719 185.569C77.8359 202.201 144.132 178.065 138.068 161.441V161.449ZM86.2359 178.033C86.0359 178.545 85.6439 178.953 85.1479 179.177C84.6519 179.401 84.0839 179.417 83.5719 179.225C83.0599 179.033 82.6439 178.641 82.4199 178.145L56.1959 119.449C55.9719 118.953 55.9559 118.385 56.1559 117.873C56.3559 117.361 56.7479 116.953 57.2439 116.729C57.7399 116.505 58.3079 116.489 58.8199 116.681C59.3319 116.873 59.7479 117.265 59.9719 117.761L86.1959 176.457H86.2039C86.4199 176.953 86.4359 177.521 86.2359 178.033ZM106.268 172.921C106.148 173.169 105.988 173.393 105.788 173.577C105.588 173.761 105.356 173.905 105.1 174.001C104.844 174.097 104.572 174.137 104.3 174.129C104.028 174.113 103.764 174.049 103.516 173.937C103.268 173.817 103.044 173.657 102.86 173.457C102.676 173.257 102.532 173.025 102.436 172.769L80.5879 112.721C80.4039 112.209 80.4359 111.641 80.6679 111.145C80.8999 110.649 81.3159 110.273 81.8279 110.081C82.3399 109.897 82.9079 109.921 83.4039 110.145C83.9079 110.369 84.2919 110.785 84.4839 111.297L106.332 171.337C106.428 171.593 106.468 171.865 106.46 172.137C106.444 172.409 106.38 172.673 106.268 172.921ZM124.924 164.153C124.66 164.625 124.22 164.969 123.7 165.113C123.188 165.257 122.628 165.201 122.156 164.945C121.676 164.697 121.324 164.265 121.156 163.753L103.524 101.921C103.38 101.393 103.452 100.833 103.716 100.353C103.988 99.8812 104.428 99.5292 104.956 99.3772C105.484 99.2252 106.044 99.2892 106.524 99.5532C107.004 99.8172 107.356 100.257 107.516 100.777L125.148 162.609H125.14C125.268 163.137 125.196 163.689 124.924 164.153Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M34.124 101.4C34.148 101.456 34.18 101.512 34.204 101.568L34.276 101.736"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M73.5002 97.9524H73.4922C62.5322 101.664 52.4602 103.824 45.2122 104.224L40.7642 98.1924V98.1444L46.3322 94.0564V94.0404L43.2042 87.6564L57.9162 76.8164L60.7962 80.7124V80.7284L62.8362 83.4884L63.3242 84.1524L65.5642 87.1924V87.1764V87.1924L65.8522 87.5764H65.8602L73.5082 97.9524H73.5002Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M46.332 94.0476V94.0556L40.772 98.1436L41.788 91.0076V90.9916L42.156 88.4316L46.324 94.0396L46.332 94.0476Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M43.1962 87.6562H43.1883L42.1562 88.4242V88.4323"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M41.788 91.0078H41.78L40.756 98.1518L40.748 98.1918L45.204 104.224"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60.7881 80.7285H60.7961L62.8281 83.4885"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M63.3159 84.1523L65.5479 87.1683L65.5559 87.1763"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M73.51 97.9631L73.5 97.9531"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M45.2119 104.235V104.225"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M40.7721 98.1445L40.7561 98.1525L40.7241 98.1765"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M43.1958 87.6584V87.6484"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M105.076 69.584C105.164 69.584 105.26 69.592 105.356 69.6C105.548 69.6 105.748 69.616 105.956 69.632C107.1 69.704 108.38 69.872 109.516 70.208C109.78 70.272 110.028 70.36 110.268 70.456C110.316 70.472 110.364 70.488 110.412 70.512C110.62 70.592 110.812 70.68 110.996 70.784C111.548 71.072 112.012 71.424 112.34 71.864C112.34 71.864 112.346 71.8693 112.356 71.88C112.42 71.96 112.476 72.04 112.524 72.128C112.58 72.216 112.636 72.312 112.668 72.408C112.716 72.496 112.756 72.592 112.78 72.688C112.82 72.792 112.844 72.896 112.868 73.008C112.868 73.016 112.868 73.024 112.868 73.032"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M112.908 73.2812C112.996 74.2333 112.62 75.3212 111.828 76.5052C111.612 76.8252 111.364 77.1533 111.092 77.4893C110.452 78.2733 109.66 79.0892 108.716 79.9372C108.212 80.3852 107.66 80.8412 107.076 81.3052"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M44.6838 104.248C44.4598 104.248 44.2438 104.264 44.0278 104.272"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M36.2358 103.272C35.2518 102.84 34.5718 102.264 34.2038 101.568C34.1798 101.512 34.1478 101.456 34.1238 101.4C33.9398 100.976 33.8678 100.512 33.9158 100C33.9158 99.9442 33.9158 99.8962 33.9318 99.8402C33.9398 99.7682 33.9558 99.6882 33.9718 99.6162C33.9878 99.5042 34.0118 99.3922 34.0518 99.2802C34.0838 99.1522 34.1238 99.0242 34.1798 98.8882C34.3078 98.5202 34.4998 98.1282 34.7398 97.7282C35.0758 97.1682 35.5078 96.5842 36.0438 95.9842C36.3398 95.6322 36.6758 95.2802 37.0358 94.9282C37.2118 94.7362 37.3958 94.5602 37.5878 94.3922C37.9718 94.0242 38.3878 93.6562 38.8278 93.2882C39.0438 93.0962 39.2758 92.9122 39.5078 92.7282C39.7398 92.5362 39.9798 92.3442 40.2278 92.1602C40.4758 91.9602 40.7318 91.7682 40.9878 91.5842C41.2438 91.3842 41.5078 91.1922 41.7798 91.0002C41.7798 90.9922 41.7878 90.9922 41.7878 90.9922"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60.7881 80.729C61.8361 80.273 62.9161 79.817 63.9961 79.377"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M64.0039 79.3848L65.5639 87.1928"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M86.2358 178.032C86.0358 178.544 85.6438 178.952 85.1478 179.176C84.6518 179.4 84.0838 179.416 83.5718 179.224C83.0598 179.032 82.6438 178.64 82.4198 178.144L56.1958 119.448C55.9718 118.952 55.9558 118.384 56.1558 117.872C56.3558 117.36 56.7478 116.952 57.2438 116.728C57.7398 116.504 58.3078 116.488 58.8198 116.68C59.3318 116.872 59.7478 117.264 59.9718 117.76L86.1958 176.456H86.2038C86.4198 176.952 86.4358 177.52 86.2358 178.032V178.032Z"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinejoin="round"
      />
      <Path
        d="M106.46 172.136C106.444 172.408 106.38 172.672 106.268 172.92C106.148 173.168 105.988 173.392 105.788 173.576C105.588 173.76 105.356 173.904 105.1 174C104.844 174.096 104.572 174.136 104.3 174.128C104.028 174.112 103.764 174.048 103.516 173.936C103.268 173.816 103.044 173.656 102.86 173.456C102.676 173.256 102.532 173.024 102.436 172.768L80.5881 112.72C80.4041 112.208 80.4361 111.64 80.6681 111.144C80.9001 110.648 81.3161 110.272 81.8281 110.08C82.3401 109.896 82.9081 109.92 83.4041 110.144C83.9081 110.368 84.2921 110.784 84.4841 111.296L106.332 171.336C106.428 171.592 106.468 171.864 106.46 172.136V172.136Z"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinejoin="round"
      />
      <Path
        d="M124.924 164.152C124.66 164.624 124.22 164.968 123.7 165.112C123.188 165.256 122.628 165.2 122.156 164.944C121.676 164.696 121.324 164.264 121.156 163.752L103.524 101.92C103.38 101.392 103.452 100.832 103.716 100.352C103.988 99.8799 104.428 99.5279 104.956 99.3759C105.484 99.2239 106.044 99.2879 106.524 99.5519C107.004 99.8159 107.356 100.256 107.516 100.776L125.148 162.608H125.14C125.268 163.136 125.196 163.688 124.924 164.152V164.152Z"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinejoin="round"
      />
      <Path
        d="M69.9639 61.0723L71.5319 69.9763"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M93.1162 56.9844L94.6842 65.8884"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M63.2598 75.1129L104.22 67.8809"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M65.8521 87.604V87.584"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M107.332 81.0798L105.076 69.5918"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M112.435 58.3134C118.715 54.8254 125.835 53.1374 133.011 53.4494C133.179 53.4494 133.347 53.4174 133.499 53.3374C133.651 53.2654 133.787 53.1534 133.891 53.0174C133.995 52.8814 134.067 52.7294 134.099 52.5614C134.131 52.3934 134.123 52.2254 134.075 52.0574C133.587 50.3694 133.331 49.3774 132.859 47.7054C128.187 48.5614 123.419 49.3054 119.027 51.3134C122.979 48.5374 127.123 45.5534 131.779 43.8094C131.307 42.0974 131.011 41.0734 130.547 39.3614C130.507 39.2014 130.427 39.0494 130.315 38.9214C130.203 38.7934 130.059 38.6974 129.907 38.6334C129.747 38.5694 129.579 38.5454 129.411 38.5614C129.243 38.5774 129.083 38.6254 128.939 38.7214C121.539 43.1774 115.355 49.3854 110.947 56.8094C110.827 57.0174 110.779 57.2654 110.811 57.4974C110.843 57.7374 110.955 57.9614 111.123 58.1294C111.291 58.2974 111.515 58.4094 111.755 58.4414C111.995 58.4734 112.235 58.4254 112.451 58.3054H112.435V58.3134Z"
        fill="#F3123C"
      />
      <Path
        d="M112.435 58.3134C118.715 54.8254 125.835 53.1374 133.011 53.4494C133.179 53.4494 133.347 53.4174 133.499 53.3374C133.651 53.2654 133.787 53.1534 133.891 53.0174C133.995 52.8814 134.067 52.7294 134.099 52.5614C134.131 52.3934 134.123 52.2254 134.075 52.0574C133.587 50.3694 133.331 49.3774 132.859 47.7054C128.187 48.5614 123.419 49.3054 119.027 51.3134C122.979 48.5374 127.123 45.5534 131.779 43.8094C131.307 42.0974 131.011 41.0734 130.547 39.3614C130.507 39.2014 130.427 39.0494 130.315 38.9214C130.203 38.7934 130.059 38.6974 129.907 38.6334C129.747 38.5694 129.579 38.5454 129.411 38.5614C129.243 38.5774 129.083 38.6254 128.939 38.7214C121.539 43.1774 115.355 49.3854 110.947 56.8094C110.827 57.0174 110.779 57.2654 110.811 57.4974C110.843 57.7374 110.955 57.9614 111.123 58.1294C111.291 58.2974 111.515 58.4094 111.755 58.4414C111.995 58.4734 112.235 58.4254 112.451 58.3054H112.435V58.3134Z"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M119.028 51.3217C137.364 41.1937 156.404 41.7057 164.956 50.5457C180.332 66.4497 164.556 106.658 129.708 140.346C94.8596 174.034 54.1636 188.458 38.7716 172.554C29.2516 162.714 31.6676 143.538 43.1636 122.394"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M62.9314 45.4576C62.8674 45.5296 62.7954 45.5936 62.7234 45.6496C62.2354 46.1136 61.7474 46.5696 61.2834 47.0096C61.2034 47.0816 61.1314 47.1536 61.0594 47.2176C60.7794 47.4736 60.5154 47.7216 60.2514 47.9616C59.9954 48.2016 59.7474 48.4256 59.5074 48.6416C59.0114 49.0896 58.5394 49.5056 58.0994 49.8976C58.0594 49.9376 58.0194 49.9696 57.9794 50.0096C57.7234 50.2256 57.4834 50.4336 57.2434 50.6416C57.1074 50.7616 56.9794 50.8736 56.8594 50.9776C55.3954 52.2176 53.0914 54.0736 50.2674 56.2096C49.8674 56.5136 49.4514 56.8176 49.0354 57.1376C48.6034 57.4576 48.1714 57.7776 47.7314 58.0976C47.2914 58.4256 46.8434 58.7456 46.3874 59.0816C46.1554 59.2496 45.9234 59.4176 45.6914 59.5856C45.2274 59.9136 44.7554 60.2496 44.2834 60.5936C43.7954 60.9296 43.3074 61.2736 42.8194 61.6096C42.0914 62.1136 41.3474 62.6256 40.5874 63.1376C40.5874 63.1376 40.5847 63.1376 40.5794 63.1376C40.0834 63.4736 39.5794 63.8096 39.0674 64.1536C38.8114 64.3296 38.5474 64.4976 38.2914 64.6576C37.5234 65.1536 36.7554 65.6496 35.9794 66.1456C29.7634 70.0496 23.4034 73.4176 18.5394 74.6176C16.3074 75.1616 14.3954 75.2496 12.9554 74.7216C12.4594 74.5376 12.0194 74.2816 11.6434 73.9456C11.6194 73.9296 11.5954 73.9056 11.5714 73.8816C11.4674 73.7856 11.3714 73.6896 11.2834 73.5856C10.1394 72.2336 10.1954 69.9776 11.2754 67.0656C11.5794 66.2256 11.9794 65.3296 12.4594 64.3856C12.6914 63.9136 12.9554 63.4256 13.2354 62.9376C13.3794 62.6896 13.5234 62.4336 13.6674 62.1856C13.9714 61.6736 14.2834 61.1616 14.6194 60.6336C15.4514 59.3056 16.4114 57.9216 17.4834 56.4896C18.7634 54.7696 20.1954 52.9696 21.7794 51.1136C22.0434 50.8016 22.3154 50.4976 22.5794 50.1856C23.6594 48.9376 24.8034 47.6736 26.0114 46.3856L27.3634 47.9536H27.3714L49.2914 29.3056L58.6114 21.3776L57.2674 19.8016H57.2754C57.2754 19.8016 57.2834 19.8016 57.2834 19.7936C59.3074 18.4416 61.2754 17.1856 63.1794 16.0496C72.2594 10.6016 79.8194 7.73758 83.9554 8.36958C84.6834 8.47358 85.3074 8.69758 85.8194 9.03358C86.0754 9.20158 86.2994 9.40158 86.4914 9.63358C91.6274 15.6336 74.2914 34.6336 62.9474 45.4576H62.9314Z"
        fill="#404040"
      />
      <Path
        d="M58.6035 21.3768L27.3476 47.9368L24.5396 44.6328L55.7955 18.0488L58.6035 21.3768Z"
        fill="#404040"
      />
      <Path
        d="M58.6035 21.3768L27.3476 47.9368L24.5396 44.6328L55.7955 18.0488L58.6035 21.3768V21.3768Z"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M58.6035 21.377L64.7955 28.657L69.3155 24.817"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M27.3477 47.9375L33.2597 54.8895L28.8117 58.6735"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M26.0036 46.377H25.9956C24.7956 47.673 23.6516 48.937 22.5636 50.185C22.2996 50.497 22.0276 50.801 21.7636 51.113C20.1876 52.969 18.7476 54.769 17.4676 56.489C16.4036 57.921 15.4436 59.305 14.6036 60.633C14.2676 61.161 13.9556 61.673 13.6516 62.185C13.5076 62.433 13.3636 62.689 13.2196 62.937C12.9476 63.425 12.6836 63.913 12.4436 64.385C11.9716 65.329 11.5716 66.225 11.2596 67.065C10.1876 69.977 10.1316 72.241 11.2756 73.585C11.3476 73.665 11.4196 73.745 11.5076 73.817C11.5396 73.865 11.5796 73.905 11.6276 73.945"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M86.4998 9.63353C86.2998 9.40153 86.0678 9.19353 85.8038 9.03353C85.2918 8.69753 84.6678 8.47353 83.9398 8.36953C79.7958 7.75353 72.2358 10.6175 63.1638 16.0495C61.2598 17.1855 59.2918 18.4415 57.2678 19.7935C57.2678 19.8015 57.2598 19.8015 57.2598 19.8015"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M63.8117 59.1288C43.0437 76.7768 22.6197 86.9048 18.2277 81.7208L11.5557 73.8808C11.5557 73.8808 11.6037 73.9288 11.6277 73.9448C12.0037 74.2808 12.4437 74.5368 12.9397 74.7208C14.3717 75.2568 16.2917 75.1688 18.5237 74.6168C23.3877 73.4248 29.7477 70.0568 35.9637 66.1448C36.7397 65.6568 37.5077 65.1608 38.2757 64.6568C38.5317 64.4968 38.7957 64.3288 39.0517 64.1528C39.5637 63.8168 40.0677 63.4808 40.5637 63.1368C40.5637 63.1368 40.5663 63.1368 40.5717 63.1368C41.3317 62.6328 42.0757 62.1208 42.8037 61.6088C43.2917 61.2728 43.7797 60.9288 44.2677 60.5928C44.7397 60.2568 45.2117 59.9208 45.6757 59.5848C45.9077 59.4168 46.1397 59.2488 46.3717 59.0808C46.8277 58.7528 47.2757 58.4248 47.7157 58.0968C48.1557 57.7768 48.5877 57.4568 49.0197 57.1368C49.4357 56.8248 49.8517 56.5128 50.2517 56.2088C53.0757 54.0728 55.3797 52.2168 56.8437 50.9768C56.9637 50.8728 57.0917 50.7608 57.2277 50.6408C57.4597 50.4488 57.7077 50.2328 57.9637 50.0088C58.0037 49.9688 58.0437 49.9368 58.0837 49.8968C58.5157 49.5208 58.9877 49.0968 59.4917 48.6408C59.7317 48.4248 59.9797 48.2008 60.2357 47.9608C60.4997 47.7208 60.7637 47.4808 61.0437 47.2168C61.1157 47.1528 61.1877 47.0808 61.2677 47.0088C61.7317 46.5768 62.2117 46.1288 62.7077 45.6488C62.7797 45.5928 62.8517 45.5288 62.9157 45.4568C73.9877 34.9368 91.7557 15.8168 86.4837 9.63281L93.4197 17.7848C97.8277 22.9528 84.5397 41.4728 63.7957 59.1288H63.8117Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.5555 73.8823L11.5075 73.8183L11.2915 73.5703"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M4.85174 122.29C4.99574 122.69 5.01974 123.122 4.91574 123.538C4.81174 123.954 4.58774 124.322 4.27574 124.61C3.96374 124.898 3.57174 125.082 3.14774 125.146C2.72374 125.21 2.29974 125.146 1.90774 124.97C1.52374 124.786 1.19574 124.498 0.979745 124.138C0.755745 123.77 0.651745 123.354 0.675745 122.93C0.691745 122.506 0.843745 122.098 1.09174 121.754C1.34774 121.41 1.69174 121.154 2.09174 121.01C2.35574 120.914 2.63574 120.874 2.92374 120.882C3.20374 120.882 3.48374 120.962 3.73974 121.082C3.99574 121.202 4.22774 121.37 4.41974 121.578C4.61174 121.786 4.75574 122.034 4.85174 122.298V122.29Z"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M120.564 1.17773L124.348 11.6097"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M127.676 4.49805L117.244 8.28205"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M167.268 143.586L151.932 149.138"
        stroke="#2E2E2E"
        strokeWidth="0.94"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_10271_164767">
        <Rect
          width="180.92"
          height="200.752"
          fill="white"
          transform="translate(0.299805 0.800781)"
        />
      </ClipPath>
    </Defs>
  </Svg>
)

export const Trash = memo(TrashIllustration)
